import { EnhancedAvailablePriceWithFareCode } from "src/ssc-api/prices/types";
import { match, P } from "ts-pattern";
import { CruiseCardModel } from "./types";

const extractPriceFromForTracking = (
  priceFrom: EnhancedAvailablePriceWithFareCode | undefined
) => {
  return match(priceFrom)
    .with(P.nullish, () => undefined)
    .with({ type: "waitlist" }, () => undefined)
    .with({ type: "price" }, (price) => price.amount)
    .with({ type: "discounted" }, (price) => price.amount)
    .exhaustive();
};

export const generateTrackingContentParams = (props: CruiseCardModel) => {
  return JSON.stringify({
    departurePort: props.departurePort?.portCode,
    arrivalPort: props.arrivalPort?.portCode,
    priceFrom: extractPriceFromForTracking(props.leadPriceFrom),
    shipName: props.shipName,
    destinationName: props.destinationName,
    voyageCode: props.voyageCode
  });
};
